module.exports = require('./lib/axios');


//////////////////
// WEBPACK FOOTER
// ./~/octa-whatsapp/~/axios/index.js
// module id = XmrL
// module chunks = 1